import { CoreButton, CoreModalDialogFooter } from '@components'
import SubmitIcon from '@images/expenses/submit-report-modal.svg?react'
import { toastSuccess } from '@utils'
import { paths, ReportStates, useSubmitReportMutation } from 'mmfintech-backend-api'
import type { ReportResponse } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import type { FC } from 'react'
import { useHistory } from 'react-router-dom'

import './reportSubmitModal.scss'

interface ReportSubmitProps {
  report: ReportResponse
  onClose: () => void
}

export const ReportSubmitModal: FC<ReportSubmitProps> = ({ report, onClose }) => {
  const [submitReportRequest, { error, isLoading }] = useSubmitReportMutation()
  const history = useHistory()

  const onConfirm = async () => {
    try {
      const result = await submitReportRequest({
        reportId: report?.id
      }).unwrap()
      toastSuccess(tr('FRONTEND.REPORTS.ACTIONS.SUBMIT_REPORT_SUCCESS', 'Report was submitted successfully'))
      if (result.state === ReportStates.APPROVED) {
        history.push(paths.expenseManagement.payments(report.id))
      }
      onClose()
    } catch {}
  }

  return (
    <div className='submit-modal-wrapper'>
      <div className='confirmation'>
        <div className='icon'>
          <SubmitIcon />
        </div>
        <div className='description'>
          {tr('FRONTEND.REPORTS.ACTIONS.SUBMIT_REPORT_DESCRIPTION', 'Are you sure you want to submit report')}:{' '}
          <span className='report-name'>{report.name}</span>
        </div>
      </div>

      <div className='error'>
        <ErrorDisplay error={error} />
      </div>

      <CoreModalDialogFooter>
        <div className='buttons-container'>
          <CoreButton
            text={tr('FRONTEND.SIGNUP.BUTTON_CREATE', 'Submit')}
            onClick={onConfirm}
            data-test='submit-report-button'
            isLoading={isLoading}
            size='large'
            variation='primary-black'
            fullWidth
          />
          <CoreButton
            variation='tertiary'
            text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            onClick={onClose}
            data-test='close-delete-report-button'
            isLoading={isLoading}
            size='large'
          />
        </div>
      </CoreModalDialogFooter>
    </div>
  )
}
